import { isBirdieGameType, isCrashGameType } from 'src/utils/gameTypeUtils'

// Which right-side past-results treatment a game gets (v8: crash results
// moved OFF the top-center strip and into this component, so every game
// surfaces its history in the same place, with the same interaction feel):
//
//   marbles — the classic recent-winners list (marble items + place labels).
//   crash   — heat-tinted multiplier pills; tapping one opens that round's
//             provably-fair modal (CrashRoundModal, Aviator pattern).
//   birdie  — B19b: the round discs (make chance + the three putts); tapping
//             one opens that round's card as a modal (BirdieRoundSheet). The
//             owner's rule for the golf game is that it renders HERE like every
//             other game rather than in a rail of its own.
export type PastResultsVariant = 'marbles' | 'crash' | 'birdie'

export function pastResultsVariant(gameType: string): PastResultsVariant {
  if (isCrashGameType(gameType)) return 'crash'
  if (isBirdieGameType(gameType)) return 'birdie'
  return 'marbles'
}
